import { NodeType, LeafTypes } from 'shared/types/ingestion'
import { INode } from 'shared/types/tree'
import {
  childNodesOfType,
  allNodesOfType,
} from 'components/utility/TreeHelpers'

export function filterQuestionToApply(node: INode): INode[] {
  const nodes = allNodesOfType(node, NodeType.Question)
  const nodesToApply: INode[] = []
  for (const question of nodes) {
    const qStandardsLists =
      childNodesOfType(question, NodeType.SkillsList) || []
    for (const list of qStandardsLists) {
      if ((list.leaves?.length ?? 0) === 0) {
        nodesToApply.push(question)
        break
      }
    }
    if (qStandardsLists.length === 0) {
      nodesToApply.push(question)
    }
  }
  return nodesToApply
}

export function filterQuestionNoList(node: INode): INode[] {
  const nodes = allNodesOfType(node, NodeType.Question)
  const nodesWithNoSkillList: INode[] = []
  for (const question of nodes) {
    const qStandardsLists =
      childNodesOfType(question, NodeType.SkillsList) || []
    if (qStandardsLists.length === 0) {
      nodesWithNoSkillList.push(question)
    }
  }
  return nodesWithNoSkillList
}

export function getStandardListWithTitle(node: INode, title: string) {
  return childNodesOfType(node, NodeType.SkillsList).filter((list) =>
    list.title.toUpperCase().includes(title.toUpperCase()),
  )
}

export function getMappedStandardsLists(
  nodes: INode[],
  standardsSelected: string,
) {
  const mapped: {
    [key: string]: { type: LeafTypes; body: { skillID: string | undefined } }[]
  } = {}
  nodes.forEach((node) => {
    const standardListWithTitle = getStandardListWithTitle(
      node,
      standardsSelected,
    )
    const standardsToApply =
      standardListWithTitle.length > 0
        ? (standardListWithTitle[0].leaves ?? [])
        : []
    const questionToApply = filterQuestionToApply(node)
    questionToApply.forEach((question) => {
      childNodesOfType(question, NodeType.SkillsList).forEach((list) => {
        mapped[list.id] = standardsToApply.map(({ body: { skillID } }) => {
          return {
            type: LeafTypes.Skill,
            body: {
              skillID: skillID,
            },
          }
        })
      })
    })
  })

  return mapped
}
